import type * as Types from 'app/types/graphql';

export type SubscriptionTrialUsageSelectFragment = Pick<
  Types.SubscriptionTrialUsage,
  'id' | 'shopPlatformID' | 'planID' | 'trialDays' | 'usedTrialDays'
>;

export type SubscriptionTrialUsageEdgeSelectFragment = Pick<
  Types.SubscriptionTrialUsageEdge,
  'cursor'
> & {
  node?: Types.Maybe<
    Pick<
      Types.SubscriptionTrialUsage,
      'id' | 'shopPlatformID' | 'planID' | 'trialDays' | 'usedTrialDays'
    >
  >;
};

export const SubscriptionTrialUsageSelectFragmentDoc = `
    fragment SubscriptionTrialUsageSelect on SubscriptionTrialUsage {
  id
  shopPlatformID
  planID
  trialDays
  usedTrialDays
}
    `;
export const SubscriptionTrialUsageEdgeSelectFragmentDoc = `
    fragment SubscriptionTrialUsageEdgeSelect on SubscriptionTrialUsageEdge {
  cursor
  node {
    ...SubscriptionTrialUsageSelect
  }
}
    `;
